import { ApiClient } from '../ApiClient';

export class LiquidityApi {
  /**
   * Constructs a new Liquidity Api.
   * @alias module:api/LiquidityApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.generalApiInstance;
  }

  /**
   *  Get initial data
   */
  async fetchData({ address, season }) {
    return await this.apiClient.callApi(
      'liquidity/stats/{address}',
      'get',
      { address },
      { season },
      null,
    );
  }

  /**
   *  Fetch liquidity airdrop leaderboard
   */
  async fetchLeaderboard({ page, limit, address, season }) {
    return await this.apiClient.callApi(
      'liquidity/leaderboard/{season}',
      'get',
      { season },
      { limit, skip: limit * (page - 1), address },
      null,
    );
  }
}
